import { LegalChrome } from './LegalChrome';

export function LicensesPage() {
  return (
    <LegalChrome>
      <h1 className="legal-h1">Open source licenses</h1>
      <p className="legal-p">
        This app uses software from the following projects. We are grateful to the open source
        community.
      </p>

      <h2 className="legal-h2">Expo</h2>
      <p className="legal-p">MIT License. Copyright (c) 2015-present Expo. https://expo.dev</p>

      <h2 className="legal-h2">React Native</h2>
      <p className="legal-p">
        MIT License. Copyright (c) Meta Platforms, Inc. and affiliates. https://reactnative.dev
      </p>

      <h2 className="legal-h2">React Native Paper</h2>
      <p className="legal-p">
        MIT License. Copyright (c) Callstack. https://callstack.github.io/react-native-paper
      </p>

      <p className="legal-p" style={{ color: '#9aa3b2' }}>
        A full list of dependencies and their licenses can be found in the project&apos;s
        package.json and node_modules. For the exact license text of any package, see the LICENSE
        file in that package&apos;s directory.
      </p>
    </LegalChrome>
  );
}
